export default __webpack_public_path__ + "static/media/image-6.6a21ac86.png";